/**
 * `GET /survey/templates` — every form the trainer has, with its counts and its roster of ids.
 *
 * Moved here from `pages/reports/api/reportsQueries` on 8 October 2026: the client card's „Przypisz
 * ankietę" reads the same list, and one key means an assignment made on either surface refreshes
 * both. `/raporty` re-exports it, so its call sites keep one import.
 */

import { queryOptions } from '@tanstack/react-query';

import { getSurveyTemplates } from '~/shared/api/generated/endpoints/survey/survey';

/**
 * The prefix every survey-template read sits under — Raporty's lists and forms, the catalog and the
 * shelf. A write that changes a template invalidates it whole.
 */
export const surveyTemplatesCacheRoot = ['reports'] as const;

/** The owner's window for a read-only preview, 3 September 2026. */
const TEMPLATES_STALE_TIME = 5 * 60 * 1000;

export const surveyTemplatesQueryKey = [...surveyTemplatesCacheRoot, 'templates'] as const;

export function surveyTemplatesQueryOptions() {
  return queryOptions({
    queryKey: surveyTemplatesQueryKey,
    // `includeLeadForm=true` lists the public form's own template beside the intake (public-form
    // R4). The phone never sends it, so it never meets the new kind.
    queryFn: ({ signal }) => getSurveyTemplates({ includeLeadForm: true }, undefined, signal),
    staleTime: TEMPLATES_STALE_TIME,
  });
}
